import React, { useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import { initGA, logPageView } from "../analytics";

import Home from './Home';
import Price from './Price';


function App() {
  useEffect(() => {
    initGA();
    logPageView();
  }, []);

  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/preco" element={<Price />} />
    </Routes>
  );
}

export default App;
